import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type DialogSelectorDocuementStylesType = {
  description: SxProps
  wrapperInputSearch: SxProps
}

export const dialogSelectorDocumentStyles: DialogSelectorDocuementStylesType = {
  description: {
    marginBottom: theme.spacing(1.5)
  },

  wrapperInputSearch: {
    width: '100%'
  }
}
